import React, { useEffect, useState } from "react";

import api from "../api/api";
import { getSession, isAdmin, isWorkspaceAdmin } from "../auth/session";
import "./Management.css";

export default function WorkspacesPage() {
  const session = getSession();
  const admin = isAdmin(session);
  const workspaceAdmin = isWorkspaceAdmin(session);
  const canUpdate = admin || workspaceAdmin;
  const canCreateDelete = admin;

  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ nome: "" });
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const loadWorkspaces = async () => {
    const res = await api.get("/workspaces/");
    setItems(res.data || []);
  };

  useEffect(() => {
    const init = async () => {
      try {
        setLoading(true);
        await loadWorkspaces();
      } catch (err) {
        setError(err?.response?.data?.detail || "Falha ao carregar workspaces.");
      } finally {
        setLoading(false);
      }
    };
    init();
  }, []);

  const clearForm = () => {
    setForm({ nome: "" });
    setEditingId(null);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      setLoading(true);
      setError("");

      if (editingId) {
        await api.put(`/workspaces/${editingId}`, { nome: form.nome });
      } else if (canCreateDelete) {
        await api.post("/workspaces/", { nome: form.nome });
      }

      await loadWorkspaces();
      clearForm();
    } catch (err) {
      setError(err?.response?.data?.detail || "Erro ao salvar workspace.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = workspace => {
    setEditingId(workspace.id);
    setForm({ nome: workspace.nome || "" });
  };

  const handleDelete = async id => {
    if (!canCreateDelete) {
      return;
    }
    if (!window.confirm("Deseja excluir este workspace?")) {
      return;
    }

    try {
      setLoading(true);
      await api.delete(`/workspaces/${id}`);
      await loadWorkspaces();
    } catch (err) {
      setError(err?.response?.data?.detail || "Erro ao excluir workspace.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="mgmt-page">
      <header className="mgmt-header">
        <div>
          <p className="mgmt-kicker">Admin</p>
          <h1 className="mgmt-title">Gestão de workspaces</h1>
        </div>
      </header>

      <section className="mgmt-card">
        <h2 className="mgmt-section-title">
          {editingId ? "Editar workspace" : canCreateDelete ? "Novo workspace" : "Configurar workspace"}
        </h2>
        {canUpdate ? (
          <form className="mgmt-form" onSubmit={handleSubmit}>
            <label className="mgmt-label" htmlFor="workspace-nome">Nome do workspace</label>
            <input
              id="workspace-nome"
              className="mgmt-input"
              placeholder="Nome do workspace"
              value={form.nome}
              onChange={e => setForm(prev => ({ ...prev, nome: e.target.value }))}
              required
            />
            <div className="mgmt-actions">
              <button className="mgmt-button" type="submit" disabled={loading}>{editingId ? "Salvar" : "Criar"}</button>
              {editingId ? <button className="mgmt-button ghost" type="button" onClick={clearForm}>Cancelar</button> : null}
            </div>
          </form>
        ) : (
          <p className="mgmt-error">Sem permissão para editar workspaces.</p>
        )}
      </section>

      <section className="mgmt-card">
        <h2 className="mgmt-section-title">Workspaces cadastrados</h2>
        {error ? <p className="mgmt-error">{error}</p> : null}
        <div className="mgmt-table-wrap">
          <table className="mgmt-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>Ativo</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {items.map(ws => (
                <tr key={ws.id}>
                  <td>{ws.id}</td>
                  <td>{ws.nome}</td>
                  <td>{ws.ativo ? "Sim" : "Não"}</td>
                  <td className="mgmt-row-actions">
                    <button className="mgmt-link-button" type="button" onClick={() => handleEdit(ws)}>Editar</button>
                    {canCreateDelete ? (
                      <button className="mgmt-link-button danger" type="button" onClick={() => handleDelete(ws.id)}>Excluir</button>
                    ) : null}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </main>
  );
}
